import { render } from "./recycleSetting.vue?vue&type=template&id=49710964&scoped=true"
import script from "./recycleSetting.vue?vue&type=script&lang=js"
export * from "./recycleSetting.vue?vue&type=script&lang=js"

import "./recycleSetting.vue?vue&type=style&index=0&id=49710964&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49710964"]])

export default __exports__